import {Lineup as BaseLineup} from 'services/sports/lol/lineup/lineup';
import $ from 'jquery';
import Action from 'actions';
import {PositionInLineup} from 'helpers/lineup-helper';
import Const from 'constants';
import {round} from 'helpers/number-helper';

export default class Lineup extends BaseLineup {
    setPlayersByColumns({incomingValues: {team}}) {
        let captain = null;
        for (let i in team) {
            const player = team[i];
            if (player.getIsCaptain()) {
                captain = {...player, positionInLineup: Const.POSITION_STAR, positionIdInLineup: 'STAR'};
                delete team[i];
                break;
            }
        }

        const {sportConfig} = Action.getState();
        const positionsOrder = sportConfig.getConfigProp('positionsOrder', {});

        const flex = PositionInLineup.set.inDependenceOnOrder({
            team: Object.values(team),
            positionsOrder,
        });

        return $.merge([captain], flex);
    }

    sumPlayersRoundedProperty({incomingValues: {players, prop, decimalPlacesCount = 0}}) {
        return players.reduce((propSum, player) => {
            const propValue = Number(player.getCapPropValue(prop));

            return propSum + round(propValue, decimalPlacesCount);
        }, 0);
    }
}
